import {flow, get, pick, pickBy, first, values, moment, createSelector} from 'helpers';
import {timestamp} from 'store/common';
import {activity} from 'store/activities/selectors';
import {record} from 'store/calendar/selectors/progress';

const meta = createSelector(
  [ activity, timestamp, state => state.activities.timers ],
  ( activity, timestamp, timers ) => activity && timers[activity.id + '_' + timestamp],
);

export const timer = createSelector(
  [ activity, record, meta ],
  ( activity, record, meta ) => {
    let data, status;
    if (activity && activity.ts) {
      data = pick(activity, 'unit', 'result');
      status = activity.status;
    } else {
      data = record && pick(record, 'unit', 'result');
      status = get(record, 'status') || 'Not Started';
    }
    return {
      result: 0,
      unit: 'stopwatch',
      activity,
      ...pickBy(data),
      ...meta,
      getTime,
      getResult,
      status,
    }
  },
  { memoizeOptions: { maxSize: 50 } },
);

const firstTimer = createSelector(
  [ state => state.activities.timers ],
  ( timers ) => first(values(timers)),
);

export const activeTimer = createSelector(
  [ firstTimer, state => state],
  flow(( firstTimer, state ) => firstTimer && timer(state, {
    id: firstTimer.activityId,
    date: firstTimer.ts
  }), timer => get(timer, 'activity') && timer)
);

function getTime() {
  const result = parseInt(this.result) || 0;
  const diff = this.started ? moment().unix() - this.started : 0;
  const duration = this.activity.duration*60;
  return this.unit == 'stopwatch' ? (diff + result) : (duration - result - diff);
}

function getResult() {
  const result = parseInt(this.result) || 0;
  return (this.started ? moment().unix() - this.started : 0) + result;
}
